// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import { TabLoader, TabConfig, addTab, removeAll } from 'wdna-components/lib/tabs';

import { hasOnePermission } from '../../../../services/user/actions';

const Dashboard: React.LazyExoticComponent<any> = React.lazy(() => import('../components/Dashboard'));

export default class Loader extends TabLoader {
  /* Override tab loader method */
  public loadTab = (tabId?: string | number): void => {
    // const access = hasOnePermission(['thralarms_ro', 'thralarms_rw']);
    const access: boolean = true;
    if (access) {
      window.store.dispatch(removeAll());

      const tabData: TabConfig = {
        id: String(tabId || window.getStr()),
        title: 'GeoPosition Dashboard',
        active: true,
        component: Dashboard,
        props: {
          report: 'DASHBOARD_GIS',
          title: 'GeoPosition Dashboard',
        },
      };

      window.store.dispatch(addTab(tabData));
    }
  };
}
